module.exports = __webpack_public_path__ + "img/click.d65902c8.png";